import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { ScheduleDataEvent } from './events';
import type { scheduleDataMachine } from './schedule-data.machine';

export const useScheduleDataRef = () => feature('schedule-data');
export const useScheduleData = <R>(selector: (snapshot: SnapshotFrom<typeof scheduleDataMachine>) => R) =>
  useFeature('schedule-data', selector);
export const useScheduleDataActions = () => {
  const ref = useScheduleDataRef();
  return {
    loadView: () => ref.send({ type: 'schedule-data.load-view' }),
    refresh: () => ref.send({ type: 'schedule-data.refresh' }),
    publish: (event: Extract<ScheduleDataEvent, { type: 'schedule-data.publish' }>['input']) =>
      ref.send({ type: 'schedule-data.publish', input: event }),
  };
};
